export default "__VITE_PUBLIC_ASSET__30580b35__"